var $ = require('jquery');

var self = {};

self.initialise = function () {
    const $footerAccordion = $('.js-footer-accordion');
    const $footerAccordionBtn = $('.js-footer-accordion-btn');
    const $footerAccordionBody = $('.js-footer-body');

    const ACTIVE = 'is-active';
    let isMobile = window.matchMedia('only screen and (max-width: 550px)').matches;

    function initAccordion() {        
        
        $footerAccordionBtn.on('click', (e) => {
            if (isMobile) {
                const $this = e.currentTarget;
                console.log($($this));
                if ($($this).hasClass(ACTIVE)) {
                    $($this).removeClass(ACTIVE);
                    $($this).closest($footerAccordion)
                        .find($footerAccordionBody).stop().slideUp();
                } else {
                    $($this).addClass(ACTIVE);
                    $($this).closest($footerAccordion)
                        .find($footerAccordionBody).stop().slideDown();
                }
            }
        });
    }

    initAccordion();

    window.addEventListener('resize', () => {
        isMobile = window.matchMedia('only screen and (max-width: 550px)').matches;
    });
};

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-footer-accordion.js